import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { aplicarTemaGuardado } from './lib/tema';
import './index.css';

// Antes do 1º render, para a página não piscar no tema errado. (Não é <script> inline no index.html:
// o portal fica pronto para uma CSP com script-src 'self'.)
aplicarTemaGuardado();

// Uma versão nova foi publicada com esta aba aberta e um pedaço sob demanda (o console) não existe
// mais: recarrega UMA vez, para pegar o index novo. A marca no sessionStorage evita recarregar em laço
// se o problema for outro (sem storage, simplesmente não recarrega).
window.addEventListener('vite:preloadError', (evento) => {
  try {
    if (sessionStorage.getItem('recarregouVersao')) return;
    sessionStorage.setItem('recarregouVersao', '1');
  } catch {
    return;
  }
  evento.preventDefault();
  window.location.reload();
});
window.addEventListener('load', () => {
  try {
    setTimeout(() => sessionStorage.removeItem('recarregouVersao'), 10_000);
  } catch {
    /* sem storage */
  }
});

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Não repetir erro de autorização/entrada: 403, 404 e 400 não melhoram tentando de novo, só
      // atrasam a mensagem para quem está olhando a tela.
      retry: (tentativa, erro: unknown) => {
        const status = (erro as { status?: number } | null)?.status ?? 0;
        return status >= 400 && status < 500 ? false : tentativa < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={cliente}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
